var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.75C10.4142 11.75 10.75 12.0858 10.75 12.5V17.5C10.75 17.9142 10.4142 18.25 10 18.25C9.58579 18.25 9.25 17.9142 9.25 17.5V12.5C9.25 12.0858 9.58579 11.75 10 11.75Z",
    fill: "#E70202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 1.75C10.1989 1.75 10.3896 1.82902 10.5303 1.96967L16.3636 7.803C16.6565 8.0959 16.6565 8.57077 16.3636 8.86366C16.0707 9.15656 15.5959 9.15656 15.303 8.86366L10.75 4.31066V12.5C10.75 12.9142 10.4142 13.25 9.99996 13.25C9.58575 13.25 9.24996 12.9142 9.24996 12.5V4.31066L4.69696 8.86366C4.40406 9.15656 3.92919 9.15656 3.6363 8.86366C3.3434 8.57077 3.3434 8.0959 3.6363 7.803L9.46963 1.96967C9.61028 1.82902 9.80105 1.75 9.99996 1.75Z",
    fill: "#E70202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.e07ca7004f31d67349cc18b2e67de425.svg";
export { ForwardRef as ReactComponent };